__turbopack_context__.v({
  "className": "great_vibes_f18ec384-module__AZvNpq__className",
});
